var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5624_193062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11.25H11.5C11.6989 11.25 11.8897 11.171 12.0303 11.0303C12.171 10.8897 12.25 10.6989 12.25 10.5C12.25 10.3011 12.171 10.1103 12.0303 9.96967C11.8897 9.82902 11.6989 9.75 11.5 9.75H9.25C9.05109 9.75 8.86032 9.82902 8.71967 9.96967C8.57902 10.1103 8.5 10.3011 8.5 10.5C8.5 10.6989 8.57902 10.8897 8.71967 11.0303C8.86032 11.171 9.05109 11.25 9.25 11.25ZM18.25 3.75H7.75C7.15326 3.75 6.58097 3.98705 6.15901 4.40901C5.73705 4.83097 5.5 5.40326 5.5 6V12.75C5.5 13.3467 5.73705 13.919 6.15901 14.341C6.58097 14.7629 7.15326 15 7.75 15H18.25C18.8467 15 19.419 14.7629 19.841 14.341C20.2629 13.919 20.5 13.3467 20.5 12.75V6C20.5 5.40326 20.2629 4.83097 19.841 4.40901C19.419 3.98705 18.8467 3.75 18.25 3.75ZM19 12.75C19 12.9489 18.921 13.1397 18.7803 13.2803C18.6397 13.421 18.4489 13.5 18.25 13.5H7.75C7.55109 13.5 7.36032 13.421 7.21967 13.2803C7.07902 13.1397 7 12.9489 7 12.75V8.25H19V12.75ZM19 6.75H7V6C7 5.80109 7.07902 5.61032 7.21967 5.46967C7.36032 5.32902 7.55109 5.25 7.75 5.25H18.25C18.4489 5.25 18.6397 5.32902 18.7803 5.46967C18.921 5.61032 19 5.80109 19 6V6.75Z",
    fill: "#6E6B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5624_193062",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5624_193062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5624_193062",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.d3690bbb90991b9087d9a65d1f01149a.svg";
export { ForwardRef as ReactComponent };